import makeStyles from '@material-ui/core/styles/makeStyles'

const barTransitionTime = 0.3

const useStyles = makeStyles(() => ({
   buttonQuestionnaire: {
      left: props =>
         props.isBarCollapsed ? '100px' : 'calc((100vw + 55px - 1000px ) / 2)',
      width: props => (props.isBarCollapsed ? '102px' : '1000px'),
      borderRadius: '14px',
      padding: '5px 1rem',
      transition: `all linear ${barTransitionTime}s`,
      maxWidth: '1000px',
      height: '92px',
      transitionDuration: `${barTransitionTime}s`,
      transitionProperty: 'width, left',
      bottom: 40,
      backgroundColor: '#008FD6',
      background:
         'transparent linear-gradient(180deg, #008FD6 0%, #154281 100%) 0% 0% no-repeat padding-box',
      position: 'fixed',
      display: 'flex',
      justifyContent: 'space-between',
      color: 'white',
      boxShadow: '0px 12px 12px #00000029'
   },

   buttonQuestionnaire_box_one: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boderColor: 'black',
      marginRight: '10px'
   },
   circle_picture_user: {
      cursor: 'pointer',
      backgroundColor: 'white',
      width: '50px',
      height: '50px',
      borderRadius: '50%'
   },
   circle_picture_user_photo: {
      width: '50px',
      height: '50px'
   },
   buttonQuestionnaire_box_two: {
      opacity: props => (props.isBarCollapsed ? 0 : 1),
      display: props => (props.isBarCollapsed ? 'none' : 'flex'),
      transition: `all ease-in ${barTransitionTime}s`,
      flexWrap: 'nowrap',
      gap: '10',
      boxSizing: 'border-box',
      fontSize: '12px',
      flexDirection: 'column',
      // justifyContent: 'center',
      borderRadius: '14px',
      padding: '0.8rem 1rem',
      boderColor: 'black',
      width: '40%',
      background:
         'transparent linear-gradient(270deg, #008FD600 0%, #154281 200%) 0% 0% no-repeat padding-box'
   },
   buttonQuestionnaire_box_three: {
      opacity: props => (props.isBarCollapsed ? 0 : 1),
      display: props => (props.isBarCollapsed ? 'none' : 'flex'),
      transition: `all ease-out ${barTransitionTime}s`,
      gap: '10',
      boxSizing: 'border-box',
      fontSize: '12px',
      flexDirection: 'row',
      // justifyContent: 'center',
      borderRadius: '50px',
      padding: '0.5rem 0.6rem',
      boderColor: 'black',
      width: '40%',
      background:
         'transparent linear-gradient(270deg, #008FD600 0%, #154281 200%) 0% 0% no-repeat padding-box'
   },
   buttonQuestionnaire_box_four: {
      opacity: props => (props.isBarCollapsed ? 0 : 1),
      display: props =>
         props.hideMenu || props.isBarCollapsed ? 'none' : 'flex',
      transition: `all ease-out ${barTransitionTime}s`,
      flexDirection: 'column',
      justifyContent: 'flex-start',
      borderRadius: '14px',
      padding: '0rem 1rem',
      boderColor: 'black',
      width: '50%',
      background:
         'transparent linear-gradient(270deg, #008FD600 0%, #154281 200%) 0% 0% no-repeat padding-box'
   }
}))

export default useStyles
